module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-bw.76bf28f7.png";